import toast from "react-hot-toast";
import { log, supabase } from ".";
import { generaComision } from "../constants/estadosEdificio";
import { EDIFICIOS_EXCLUIDOS } from "../constants/permisos";

// Predicado ÚNICO de "operativo comercial" (regla 10.1): genera comisión (OPERATIVO) + vivo
// (eliminada=false) + no está en el parche EDIFICIOS_EXCLUIDOS (cartelería pura / excluidos a mano).
// Es la definición canónica de "cantidad de edificios operativos" para inventario/badges/landings.
// Comparación por ID (regla 10.7). Lo consumen el fetch de abajo Y los conteos que ya tienen el
// array de edificios cargado (EdificiosTable badge, InventarioSimple KPI) — sin refetch ni reimplementar.
export const esOperativoComercial = (edificio) =>
  generaComision(edificio.estado) && !edificio.eliminada && !EDIFICIOS_EXCLUIDOS.includes(edificio.id);

export const getEdificiosOperativos = async ({ pais }) => {
  try {
    // Asumiendo que supabase.select es la forma correcta de hacer la consulta en tu configuración
    const data = await supabase.select("edificios", {
      filters: {
        pais,
      },
      orderBy: "pantallas",
      ascending: false,
    });

    // Filtrar por estado que genera comisión (OPERATIVO) — fuente única estadosEdificio.
    // Solo vivos (eliminada=false). Excluir EDIFICIOS_EXCLUIDOS (parche, ver Bloque E).
    const filteredData = data.filter(esOperativoComercial);

    if (filteredData.length === 0) {
      toast.error("No hay edificios cargados en la base de datos");
      throw new Error("No data found");
    }

    return filteredData;
  } catch (error) {
    log.error("getEdificiosOperativos", error);
    throw error;
  }
};

// "Mayúsculas, sin tildes" — normaliza el `estado` de la DB ("INSTALACIÓN") al token pedido por el
// Radar ("INSTALACION"), sin tocar `estadosEdificio.js` (esa fuente sigue con tilde, es el dominio
// real del CHECK de la DB).
const normalizarEstadoSinTilde = (estado) => (estado || "").normalize("NFD").replace(/[̀-ͯ]/g, "");

/**
 * Desglose de la red por estado (Radar Comercial, `{frase_red}` — docs/decisiones/2026-09-26-
 * radar-mail-pagina-diseno.md §12): `operativos` reproduce EXACTAMENTE el mismo predicado que
 * `getEdificiosOperativos`/`esOperativoComercial` (10.229 — un desglose no puede reportar un
 * "operativos" distinto del M que ya se muestra en el resto de la app), así que vive JUNTO a esa
 * función (10.1) y comparte su misma base (vivo + no EDIFICIOS_EXCLUIDOS). `instalacion`/`piloto`
 * son nuevos para el Radar — misma base, sin predicado propio en `estadosEdificio.js` todavía.
 * `personasOperativos` (2026-09-27, bloque 0 "Asunto" del mail del Radar): suma de `personas` de
 * los mismos edificios operativos, mismo cálculo que Inventario (`InventarioAvanzado`/
 * `InventarioSimple`, `reduce` sobre `esOperativoComercial`) — reusa el fetch ya hecho acá, sin
 * query nueva.
 */
export const getConteoRedPorEstado = async ({ pais }) => {
  try {
    const data = await supabase.select("edificios", { filters: { pais } });
    const vivos = (data || []).filter((e) => !e.eliminada && !EDIFICIOS_EXCLUIDOS.includes(e.id));

    const conteo = { operativos: 0, instalacion: 0, piloto: 0, personasOperativos: 0 };
    for (const edificio of vivos) {
      const estado = normalizarEstadoSinTilde(edificio.estado);
      if (estado === "OPERATIVO") {
        conteo.operativos += 1;
        conteo.personasOperativos += edificio.personas || 0;
      } else if (estado === "INSTALACION") conteo.instalacion += 1;
      else if (estado === "PILOTO") conteo.piloto += 1;
    }
    return conteo;
  } catch (error) {
    log.error("getConteoRedPorEstado", error);
    throw error;
  }
};
